module.exports = __webpack_public_path__ + "img/FS_Fantasy sword.fddc73b0.png";